/**
 * Created by xuxin06@meituan.com on 2017/7/24.
 */
// import LoadingComp from 'components/loading.vue'
import ticket from './router.ticket'
import ViewWrapper from 'components/view-wrapper/view-wrapper.vue';
import jiujing from './router.jiujing';
import jijiu from './router.jijiu';
import chepiao from './router.chepiao';
import gty from './router.gty';
import ticketng from './router.ticketng';
import accountRoutes from './router.account';
import purseRoutes from './router.purse';
import notificationRoutes from './router.notification';
import wenChuang from './router.wenchuang';
import infos from './router.info';
export default [{
    name: 'login',
    path: '/login',
    component: require('views/login/Main.vue'),
    meta: {
        noAuth: true,
        noUser: true
    }
},
{
    path: '/ticketold',
    component: require('views/ticket/Main.vue'),
    children: ticket
},
{
    name: 'comment',
    path: '/:type/comment/:id?/:name?',
    component: require('views/comment/list/Main.vue'),
    meta: {
        noAuth: true
    }
},
{
    name: 'operateData',
    path: '/:type/dataPlatform/operateData',
    component: require('views/dataPlatform/operateData/Main.vue')
},
{
    name: 'productData',
    path: '/:type/dataPlatform/productData',
    component: require('views/dataPlatform/productData/Main.vue')
},
{
    name: 'serviceData',
    path: '/:type/dataPlatform/serviceData',
    component: require('views/dataPlatform/serviceData/Main.vue')
},
{
    name: 'newHome',
    path: '',
    component: require('views/layout/Main.vue'),
    children: [{
        path: 'ticket',
        component: ViewWrapper,
        children: ticketng,
        meta: {
            name: 'tickethome',
            bizName: '门票',
            bizLineValue: 'lvyou-ticket'
        }
    }, {
        path: 'jiujing',
        component: ViewWrapper,
        children: jiujing,
        meta: {
            name: 'jiujinghome',
            bizName: '景酒套餐',
            bizLineValue: 'open-jingjiu'
        }
    }, {
        path: 'gty',
        component: ViewWrapper,
        children: gty,
        meta: {
            name: 'gtyhome',
            bizName: '跟团游',
            bizLineValue: 'open-gentuanyou'
        }
    }, {
        path: 'jijiu',
        component: ViewWrapper,
        children: jijiu,
        meta: {
            name: 'jijiuhome',
            bizName: '机酒套餐',
            bizLineValue: 'open-jijiu'
        }
    }, {
        path: 'chepiao',
        component: ViewWrapper,
        children: chepiao,
        meta: {
            name: 'chepiaohome',
            bizName: '旅游用车',
            bizLineValue: 'open-cheliang'
        }
    }, {
        path: 'wenchuang',
        component: ViewWrapper,
        children: wenChuang,
        meta: {
            name: 'wenchuanghome',
            bizName: '实物电商',
            bizLineValue: 'open-wenchuang'
        }
    }, {
        path: 'account',
        component: ViewWrapper,
        children: accountRoutes,
        meta: {
            notBizMenu: true,
            name: 'adminAccount'
        }
    }, {
        path: 'purse',
        component: ViewWrapper,
        children: purseRoutes,
        meta: {
            notBizMenu: true,
            name: 'purseList'
        }
    }, {
        path: 'notification',
        component: ViewWrapper,
        children: notificationRoutes,
        meta: {
            notBizMenu: true,
            name: 'notificationList'
        }
    }, {
        path: 'info',
        component: ViewWrapper,
        children: infos,
        meta: {
            notBizMenu: true,
            name: 'jiujingauthInfo'
        }
    }, {
        name: 'systemSetting',
        path: 'setting',
        component: require('views/setting/setting.vue'),
        meta: {
            noAuth: true,
            notBizMenu: true
        }
    }]
},
{
    path: '/403',
    component: require('components/403.vue')
},
{
    path: '/home',
    component: require('components/Home.vue')
},
{
    name: 'merchnatAcademy',
    path: '/merchnat/academy/:bizLineId',
    component: require('views/academy/HomePage.vue')
},
{
    name: 'announceDetail',
    path: '/announce/:id',
    component: require('views/academy/AnnounceDetail.vue'),
    meta: {
        noAuth: true
    }
}, {
    name: 'unauthorized',
    path: '/unauthorized',
    component: require('views/unauthorized/Main.vue'),
    meta: {
        noAuth: true
    }
},
{
    path: '*',
    component: require('components/404.vue'),
    meta: {
        noAuth: true
    }
},
{
    name: 'gtyProgramData',
    path: '/gtyDataCenter/programData',
    component: require('views/gtyDataCenter/programData.vue')
},
{
    name: 'gtyOperationData',
    path: '/gtyDataCenter/operationData',
    component: require('views/gtyDataCenter/operationData.vue')
},
{
    name: 'customerSourceAnalyse',
    path: '/newGtyDataCenter/customerSourceAnalyse',
    component: require('views/newGtyDataCenter/customerSourceAnalyse.vue')
}
]


// WEBPACK FOOTER //
// ./src/router/router.config.js